module.exports = __webpack_public_path__ + "static/media/Illustration3.fd3a054f.png";